// extracted by mini-css-extract-plugin
export default {"toast":"SubscriptionsPlansPage_toast__vo0En"};